import React, { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

import { TextRegStyle } from '~/atomic/Typography';

type DescriptionProps = {
  data: ReactNode[];
} & HTMLAttributes<HTMLUListElement>;

export const Description = ({ data, ...props }: DescriptionProps) => {
  return (
    <SCDescription {...props}>
      {data.map((item, i) => (
        <SCDescriptionItem key={i}>
          {item}
        </SCDescriptionItem>
      ))}
    </SCDescription>
  );
};

const SCDescriptionItem = styled.li`
  ${TextRegStyle};
  position: relative;
  margin-left: 14px;
  white-space: break-spaces;

  &:after {
    content: '';
    display: block;
    width: 3px;
    height: 3px;
    position: absolute;
    top: 8px;
    left: -12px;
    border-radius: 50%;
    background-color: var(--black-color);
  }
`;

const SCDescription = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
